module.exports = __webpack_public_path__ + "static/assets/b8a3473f83ae0ced569ce45528a8d150.svg";